var EHDI = EHDI || Object.create(null);

EHDI.popup = EHDI.popup || Object.create(null);

EHDI.popup.PausePopUp = function() {
    EHDI.aka.Container.call(this);
    
    var _overlay, _header, _container, _pauseLabel, _htpImage, _rightArrow, _leftArrow, _indicatorContainer, _homeButton, _newInstruction, _newLabel;
    
    var _isMobile = EHDI.BrowserInfo.isMobileDevice ? "mobile_" : "desktop_";
    var _pageCount = 3;
    
    var _indicators = [],
        _htpLabel,
        _pageNumber = 0,
        _pauseTimeline = new TimelineMax( { autoRemoveChildren: true } ),
        _resumeGame = false;
    
    var _spacebar = EHDI.interactions.Keyboard(32),
        _aKey = EHDI.interactions.Keyboard(65),
        _lKey = EHDI.interactions.Keyboard(76);
    
    var closePopUp = function() {
        _spacebar.dispose();
        _aKey.dispose();
        _lKey.dispose();
        EHDI.GAME.soundManager.playSFX("button_01");
        _resumeGame = true;
        EHDI.GAME.sceneManager.popPopUp({y : new EHDI.scene.TransitionParameter(0, -EHDI.screen.stageHeight), duration : 0.2});
    }
    
    
    this.popUpWillAppear = function() {
        
        _overlay = new EHDI.aka.Sprite(EHDI.displays.TextureRectangle(0x00000, EHDI.screen.stageWidth, EHDI.screen.stageHeight));
        _overlay.anchor.set(0.5, 0.5);
        _overlay.alpha = 0;
        
        _overlay.interactive = true;
        
        this.addChild(_overlay)
        
        /*
        _header = new EHDI.aka.Sprite( EHDI.Assets.images["WB_con_header"] );
        _header.anchor.set( 0.5, 1.0 );
        
        _pauseLabel = new EHDI.aka.PixiText( EHDI.localization.strings["paused"].content, {
            fontFamily: "nuevastd-bold", 
            fontSize: EHDI.localization.strings["paused"].size, 
            align: 'center', 
            fill: '#592E0E'
        });
        _pauseLabel.anchor.set( 0.5, 1.0 );
        _pauseLabel.position.set( _header.width * 0.003, -_header.height * 0.05 );
        _header.addChild( _pauseLabel );
        //*/
        
        _container = new EHDI.aka.Sprite(EHDI.Assets.images["WB_con_pause"]);
        _container.anchor.set(0.5, 0.5);
        _container.position.y = -EHDI.screen.stageHeight * 0.1;
        this.addChild(_container);
        
        _htpImage = new EHDI.aka.Sprite( EHDI.Assets.images[ "htp_" + _isMobile + 0 ] );
        _htpImage.anchor.set(0.5, 0.5);
        _htpImage.position.y = -_container.height * 0.15;
        _container.addChild(_htpImage);
        
        
        _indicatorContainer = new EHDI.aka.Container();
        _container.addChild(_indicatorContainer);
        
        for(var i = 0; i < _pageCount; i++) {
            var indicator = new EHDI.aka.Sprite(EHDI.Assets.images[(i === _pageNumber) ? "htp_pg_1" : "htp_pg_0"]);
            indicator.anchor.set(0, 0.5);
            indicator.position.set((indicator.width + _container.width * 0.05) * i, 0);
            _indicatorContainer.addChild(indicator);
            _indicators.push(indicator);
        }
        _indicatorContainer.position.set(-_indicatorContainer.width * 0.5, _container.height * 0.18);
        
        var htpMessage = _isMobile + "htp" + 0;
        _htpLabel = new EHDI.aka.PixiText( EHDI.localization.strings[ htpMessage ].content, {
            fontFamily: "nuevastd-bold", 
            fontSize: EHDI.localization.strings[ htpMessage ].size, 
            align: 'center',
            wordWrap: true,
            wordWrapWidth: _container.width * 0.9,
            fill: '#592E0E'
        });
        _htpLabel.anchor.set( 0.5, 0.5 );
        _htpLabel.position.set( _container.width * 0.003, _container.height * 0.315 );
        _container.addChild( _htpLabel );
        
        _newLabel = new EHDI.aka.PixiText( EHDI.localization.strings[ htpMessage ].content, {
            fontFamily: "nuevastd-bold", 
            fontSize: EHDI.localization.strings[ htpMessage ].size, 
            align: 'center',
            wordWrap: true,
            wordWrapWidth: _container.width * 0.9,
            fill: '#592E0E'
        });
        _newLabel.anchor.set( 0.5, 0.5 );
        _newLabel.position.set( _htpLabel.position.x, _htpLabel.position.y );
        _container.addChild( _newLabel );
        _newLabel.alpha = 0;
        
        //_container.addChild( _header );
        //_header.position.y = -_container.height * 0.47;
    };
    
    this.popUpDidAppear = function() {
        _overlay.alpha = 0.5;
        
        _leftArrow = new EHDI.displays.Button(EHDI.Assets.images["btn_htp_next"], null, null, null);
        _leftArrow.anchor.set( 0.5, 0.5 );
        _leftArrow.scale.set(-1, 1);
        _leftArrow.baseScale.x = -1;
        _leftArrow.baseScale.y = 1;
        _leftArrow.customScale = {x : -0.85, y : 0.85};
        _leftArrow.position.set(-_container.width * 0.4, -_container.height * 0.15);
        _container.addChild(_leftArrow)
        _leftArrow.setOnClickFunction(previousPage);
        
        _rightArrow = new EHDI.displays.Button(EHDI.Assets.images["btn_htp_next"], null, null, null);
        _rightArrow.anchor.set( 0.5, 0.5 );
        _rightArrow.baseScale.x = 1;
        _rightArrow.baseScale.y = 1;
        _rightArrow.customScale = {x : 0.85, y : 0.85};
        _rightArrow.position.set(_container.width * 0.4, -_container.height * 0.15);
        _container.addChild(_rightArrow);
        _rightArrow.setOnClickFunction(nextPage);
        
        _homeButton = new EHDI.displays.Button(EHDI.Assets.images["btn_home"], null, null, null, 0.8);
        _homeButton.position.set(-EHDI.screen.stageWidth * 0.2, EHDI.screen.viewHeight * 0.36);
        _homeButton.setOnClickFunction(openConfirmation);
        this.addChild(_homeButton);
        
        var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
        _soundButton = new EHDI.displays.ToggleButton(EHDI.Assets.images["btn_audio_1"], EHDI.Assets.images["btn_audio_1"], EHDI.Assets.images["btn_audio_0-2"], EHDI.Assets.images["btn_audio_0-2"], cache.isMuted, 0.8);
        _soundButton.position.set(EHDI.screen.stageWidth * 0.2, EHDI.screen.viewHeight * 0.36);
        this.addChild(_soundButton);
        _soundButton.setOnClickFunction(toggleAudio);
        
        _playButton = new EHDI.displays.Button(EHDI.Assets.images["btn_play"], null, null, null, 0.8);
        _playButton.position.set(0, EHDI.screen.viewHeight * 0.36);
        this.addChild(_playButton);
        _playButton.setOnClickFunction(closePopUp);
        
        _pauseTimeline.from(_homeButton.scale, 0.1, {x : 0, y : 0});
        _pauseTimeline.from(_soundButton.scale, 0.1, {x : 0, y : 0});
        _pauseTimeline.from(_playButton.scale, 0.1, {x : 0, y : 0})
        _pauseTimeline.from(_leftArrow.scale, 0.1, {x : 0, y : 0});
        _pauseTimeline.from(_rightArrow.scale, 0.1, {x : 0, y : 0}, "-=0.1");
        
        _spacebar.press = closePopUp;
        _aKey.press = closePopUp;
        _lKey.press = closePopUp;
    };
    
    var nextPage = function() {
        EHDI.GAME.soundManager.playSFX("button_01");
        _pageNumber++;
        if(_pageNumber >= _pageCount) {
            _pageNumber = 0;
        }
        
        changePage();
    }
    
    var previousPage = function() {
        EHDI.GAME.soundManager.playSFX("button_01");
        _pageNumber--;
        if(_pageNumber < 0) {
            _pageNumber = _pageCount - 1;
        }
        
        changePage();
    }
    
    var changePage = function() {
        if(_pauseTimeline) {
            _pauseTimeline.kill()
            _pauseTimeline.clear();
        }
        
        if(_newInstruction && _newInstruction.alpha !== 1) {
            _newInstruction.alpha = 1;
            _htpImage.destroy();
            _htpImage = _newInstruction;
            _newInstruction = null;
        }
        
        for(var i = 0; i < _indicators.length; i++) {
            _indicators[i].texture = EHDI.Assets.images[(i === _pageNumber) ? "htp_pg_1" : "htp_pg_0"];
        }
        
        _newLabel.alpha = 0;
        _newLabel.text = EHDI.localization.strings[ _isMobile + "htp" + _pageNumber ].content;
        _htpLabel.alpha = 1;
            
        _newInstruction = new EHDI.aka.Sprite( EHDI.Assets.images[ "htp_" + _isMobile + _pageNumber ] );
        _newInstruction.anchor.set(0.5, 0.5);
        _newInstruction.position.y = -_container.height * 0.15;
        _container.addChild(_newInstruction);
        
        _pauseTimeline.add( "next", "+=0" )
        _pauseTimeline.from(_newInstruction, 0.5, {alpha : 0}, "next");
        _pauseTimeline.to(_htpImage, 0.5, {alpha : 0}, "next");
        _pauseTimeline.to(_newLabel, 0.5, {alpha : 1}, "next");
        _pauseTimeline.to(_htpLabel, 0.5, {alpha: 0}, "next");
        _pauseTimeline.add(onChangePageFinished);
    };
    
    var onChangePageFinished = function () {
        if(_htpImage) {
            _htpImage.destroy();
            _htpImage = _newInstruction;
            _htpImage.alpha = 1;
            _newInstruction = null;
            
            _newLabel.alpha = 0;
            _htpLabel.text = EHDI.localization.strings[ _isMobile + "htp" + _pageNumber ].content;
            _htpLabel.alpha = 1;
        }
    }
    
    this.popUpWillDisappear = function() {
        _overlay.alpha = 0;
    }
    
    this.popUpDidDisappear = function() {
        if(_resumeGame) 
            EHDI.GAME.gameScene.pauseManager.resumeGame();
    }
    
    
   
    var openConfirmation = function() {
        EHDI.GAME.soundManager.playSFX("button_01");
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.ConfirmPopUp(), {y : new EHDI.scene.TransitionParameter(- EHDI.screen.stageHeight, 0), duration : 0.25});
        //EHDI.GAME.sceneManager.popPopUp();
        //EHDI.GAME.sceneManager.changeScene( new EHDI.scene.TitleScene() ); // temp
    }
    
    var toggleAudio = function(enable) {
        EHDI.GAME.soundManager.setMute(enable);
        var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
        cache.isMuted = enable;
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
        EHDI.GAME.soundManager.playSFX("button_01");
    }
    
    this.onScreenResize = function() {
        _container.position.y = -EHDI.screen.stageHeight * 0.1;
        _homeButton.position.set(-EHDI.screen.stageWidth * 0.2, EHDI.screen.viewHeight * 0.36);
        _soundButton.position.set(EHDI.screen.stageWidth * 0.2, EHDI.screen.viewHeight * 0.36);
        _playButton.position.set(0, EHDI.screen.viewHeight * 0.36);
    }
}

EHDI.popup.PausePopUp.prototype = Object.create(EHDI.aka.Container.prototype);

